export type TeacherPlanId = 'free' | 'class' | 'school';

export interface TeacherPlan {
  id: TeacherPlanId;
  name: string;
  summary: string;
  features: string[];
}

export const TEACHER_PLANS: TeacherPlan[] = [
  {
    id: 'free',
    name: '무료',
    summary: '학급을 열고 출결, 일정, 글 공지를 운영합니다.',
    features: ['학급 명단', '출결', '일정', '공지', '메시지'],
  },
  {
    id: 'class',
    name: '학급',
    summary: '포인트, 상점, 자리, 역할, 자료 파일까지 한 학급을 운영합니다.',
    features: ['무료 기능', '학급 자료', '포인트·상점', '자리·역할·경매', '투표·업적·가상펫'],
  },
  {
    id: 'school',
    name: '학교',
    summary: '학급 기능에 교과 도장과 교과 운영을 더합니다.',
    features: ['학급 기능', '교과 운영', '도장', '여러 수업 관리'],
  },
];

const PLAN_RANK: Record<TeacherPlanId, number> = {
  free: 0,
  class: 1,
  school: 2,
};

const FREE_MENU_IDS = new Set([
  'dashboard',
  'schedule',
  'messages',
  'settings',
  'class-management',
  'attendance-management',
]);

const CLASS_PATH_PREFIXES = [
  '/class/teacher/ClassMaterials',
  '/class/teacher/SeatManagement',
  '/class/teacher/ClassRoleManagement',
  '/class/teacher/VoteManagement',
  '/class/teacher/AchievementManagement',
  '/class/teacher/VirtualPetManagement',
  '/class/teacher/MyHomeModeration',
  '/class/teacher/ManitoManagement',
  '/class/teacher/BirthdayManagement',
  '/class/teacher/DailyMission',
  '/class/teacher/RoleAuctionManagement',
  '/class/teacher/Lottery',
  '/class/teacher/PointApprovalManagement',
  '/class/teacher/point-approval',
  '/class/teacher/special-point-approval',
  '/class/teacher/ClassPointManagement',
  '/class/teacher/StoreManagement',
  '/class/teacher/ItemApproval',
  '/class/student/Vote',
  '/class/student/RoleAuction',
  '/class/student/SeatReservation',
  '/class/student/VirtualPet',
  '/class/student/CharacterWardrobe',
  '/class/student/Manito',
  '/class/student/BirthdayRollingPaper',
  '/class/student/StudentClassPoints',
  '/class/student/StudentAchievements',
  '/class/student/ClassItemShop',
  '/class/student/ClassMyItems',
  '/class/student/MyHome',
];

export function storedTeacherPlan(plan: unknown): TeacherPlanId | null {
  if (plan === 'free' || plan === 'class' || plan === 'school') return plan;
  return null;
}

/** plan 필드가 없는 기존 교사는 학교 요금제로 본다. 새 교사는 승인 때 'free'가 저장된다. */
export function resolveTeacherPlan(plan: unknown, role?: string | null): TeacherPlanId {
  if (role === 'superAdmin' || role === 'schoolAdmin') return 'school';
  if (plan === 'free' || plan === 'class' || plan === 'school') return plan;
  if (plan === undefined || plan === null) return 'school';
  return 'free';
}

export function planMeets(plan: TeacherPlanId, required: TeacherPlanId): boolean {
  return PLAN_RANK[plan] >= PLAN_RANK[required];
}

export function requiredPlanForPath(pathname: string): TeacherPlanId | null {
  if (pathname.startsWith('/subject')) return 'school';
  if (CLASS_PATH_PREFIXES.some((prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`))) {
    return 'class';
  }
  return null;
}

export function isMenuAllowed(plan: TeacherPlanId, menuId: string, navbarType: string): boolean {
  if (navbarType === 'subject') return plan === 'school' || menuId === 'dashboard';
  if (navbarType !== 'teacher-class' && navbarType !== 'student-class') return true;
  if (plan === 'school' || plan === 'class') return true;
  return FREE_MENU_IDS.has(menuId);
}
